// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Cameroon */
const CM = /^(?:(?:24[23]|6(?:[25-9]\d|4[0-2]))\d{6})$/;

export default CM;
